'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowModal = exports.ShowModalUnwrapped = exports.mapDispatchToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _modals = require('redux/modules/modals');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = {
  showModal: _modals.showModal
};

var ShowModalUnwrapped = exports.ShowModalUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ShowModalUnwrapped, _PureComponent);

  function ShowModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, ShowModalUnwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ShowModalUnwrapped)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ShowModalUnwrapped, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          modalName = _props.modalName,
          modalProps = _props.modalProps,
          onClick = _props.onClick,
          localShowModal = _props.showModal;


      if (onClick) {
        onClick.apply(undefined, arguments);
      }

      localShowModal(modalName, modalProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children;


      return _react2.default.createElement(
        'span',
        {
          className: (0, _classnames2.default)('qa-button', className),
          onClick: this.handleClick
        },
        children
      );
    }
  }]);
  return ShowModalUnwrapped;
}(_react.PureComponent);

ShowModalUnwrapped.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  modalName: _propTypes2.default.string.isRequired,
  modalProps: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func,
  showModal: _propTypes2.default.func.isRequired
};

var reduxDecorator = (0, _reactRedux.connect)(null, mapDispatchToProps);

var ShowModal = exports.ShowModal = reduxDecorator(ShowModalUnwrapped);